import { Typography } from "@mui/material"

export const Introduction = () => {
    return (
        <Typography variant="body2" color="white">
            相模ボンバーズは、相模原市立相模台小学校をホームグラウンドとし、1973年から活動する軟式野球チームです。
        </Typography>
    )
}
